import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getLocales } from 'expo-localization'
import it from '../locales/it/translation.json'
import en from '../locales/en/translation.json'
import es from '../locales/es/translation.json'
import fr from '../locales/fr/translation.json'
import de from '../locales/de/translation.json'
import pt from '../locales/pt/translation.json'
import da from '../locales/da/translation.json'
import nl from '../locales/nl/translation.json'
import no from '../locales/no/translation.json'
import sl from '../locales/sl/translation.json'

const deviceLanguage = getLocales()?.[0]?.languageCode ?? 'it'
const supportedLngs = ['it', 'en', 'es', 'fr', 'de', 'pt', 'da', 'nl', 'no', 'sl']
const detectedLng = supportedLngs.includes(deviceLanguage) ? deviceLanguage : 'it'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      pt: { translation: pt },
      da: { translation: da },
      nl: { translation: nl },
      no: { translation: no },
      sl: { translation: sl },
    },
    lng: detectedLng,
    fallbackLng: 'it',
    supportedLngs,
    interpolation: { escapeValue: false },
  })

export default i18n
